type Prices = { msrp_usd?: number | null; msrp_mxn?: number | null };
type PricedVariant = Prices & { attributes?: Record<string, unknown> | null };

export function variantPrice(product: Prices, selected: PricedVariant | null, variants: PricedVariant[]) {
  // A variant's price is one currency pair; never mix it with its parent's USD price.
  if (selected && (selected.msrp_usd != null || selected.msrp_mxn != null)) {
    return { usd: selected.msrp_usd ?? null, mxn: selected.msrp_mxn ?? null };
  }
  const sizeKeys = new Set(variants.flatMap(v => Object.keys(v.attributes ?? {})).filter(k => /dimen|longitud|largo|length|size|tama[ñn]o/i.test(k)));
  const sizeVaries = [...sizeKeys].some(key => new Set(variants.map(v => String(v.attributes?.[key] ?? '')).filter(Boolean)).size > 1);
  // An unpriced size must be quoted, rather than presented at another size's price.
  if (selected && sizeVaries) return { usd: null, mxn: null };
  return { usd: product.msrp_usd ?? null, mxn: product.msrp_mxn ?? null };
}
